import { qsa } from "@fluorescent/dom";

import { section } from "@/glow";
import videoPlayerBlock from "@/lib/video-player-block";
import { animateMediaWithContent, shouldAnimate } from "@/lib/animation";

const selectors = {
  videoPlayerVideo: "[data-video-player-block-video]",
  videoPlayerBlock: ".video-player-block",
};

section("overlapping-media-with-content", {
  onLoad() {
    if (shouldAnimate(this.container)) {
      this.animateMediaWithContent = animateMediaWithContent(this.container);
    }

    const videoPlayerVideos = qsa(selectors.videoPlayerVideo, this.container);

    if (videoPlayerVideos.length) {
      this.videoPlayers = videoPlayerVideos.map(block =>
        videoPlayerBlock(block.closest(selectors.videoPlayerBlock))
      );
    }
  },

  onUnload() {
    this.animateMediaWithContent?.destroy();
    this.videoPlayers && this.videoPlayers.forEach(button => button.unload());
  },
});
